import api from "./apiSmartLogistics";

export default {
  GetExtractions() {
    return api.get("Extractions/GetExtractions");
  },
  GetExtraction(id) {
    return api.get("Extractions/GetExtraction/" + id);
  },
  AddExtraction(extraction) {
    return api.post("Extractions", extraction);
  },
  UpdateExtraction(extraction) {
    return api.put("Extractions", extraction);
  },
  DeleteExtraction(id) {
    return api.delete("Extractions/DeleteExtraction/" + id);
  },
  SearchExtractions(value) {
    return api.get("Extractions/SearchExtractions/" + value);
  },
  SearchStringQueryCustom(id) {
    return api.get("Extractions/SearchStringQueryCustom/" + id);
  },
  ExecuteQuery(json) {
    return api.post("Extractions/ExecuteQuery", json, {
      headers: { "Content-Type": "application/json" }
    });
  }
};
